import React from 'react';
type BadgeVariant = 'green' | 'yellow' | 'red' | 'indigo' | 'gray';
interface BadgeProps {
  variant: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}
export const Badge: React.FC<BadgeProps> = ({
  variant,
  children,
  className = ''
}) => {
  const variantClasses = {
    green: 'bg-green-3 text-green-11',
    yellow: 'bg-yellow-3 text-yellow-11',
    red: 'bg-red-3 text-red-11',
    indigo: 'bg-indigo-3 text-indigo-11',
    gray: 'bg-gray-3 text-gray-11'
  };
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium ${variantClasses[variant]} ${className}`} data-id="element-544">
      {children}
    </span>;
};